var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-overlay',{attrs:{"color":"light-bg"}},[_c('lottie-vue-player',{attrs:{"src":_vm.loading_animation,"autoplay":true,"loop":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }